"use client";

import { useClipboard } from "@mantine/hooks";
import { Icon, cn } from "@repo/dashboard-core";

export function CopyableValue({
  value,
  copyValue,
  className,
}: {
  value: string;
  /** Copied instead of `value` when the display is grouped or abbreviated. */
  copyValue?: string;
  className?: string;
}) {
  const { copy, copied } = useClipboard({ timeout: 2000 });

  return (
    <button
      type="button"
      onClick={() => copy(copyValue ?? value)}
      className={cn(
        "inline-flex items-center gap-1.5 transition-colors",
        className,
      )}
    >
      <span>{value}</span>
      {copied ? (
        <span className="text-emerald-600">
          <Icon name="checkmark" size={16} />
        </span>
      ) : (
        <span className="text-text-secondary hover:text-primary">
          <Icon name="copy" size={16} />
        </span>
      )}
    </button>
  );
}
